// extracted by mini-css-extract-plugin
module.exports = {"link":"BaseLink_link__3HFN3","primary":"BaseLink_primary__3qLFI","secondary":"BaseLink_secondary__UaYe1","header":"BaseLink_header__2mtNO"};